import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAe6qONnO23dpSyt-Z3OAfmn8LC9u3xq28",
  authDomain: "healthhub-emr.firebaseapp.com",
  projectId: "healthhub-emr",
  storageBucket: "healthhub-emr.firebasestorage.app",
  messagingSenderId: "387023880202",
  appId: "1:387023880202:web:9174968ff41e8663df1ff3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)

export { app, auth };